// Company + content data for Carnier Toiture et Habitat

export const COMPANY = {
  name: "Carnier Toiture et Habitat",
  short: "Carnier",
  phone: "07 69 53 51 60",
  phoneRaw: "0769535160",
  email: "contact@carnier-toitureethabitat.com",
  experience: "15 ans",
  team: "3 artisans",
  zonePrincipale: "Oise",
  zonesElargies: ["Île-de-France", "Picardie"],
  baseline: "Rénovation, entretien et amélioration de l'habitat",
};

export const IMAGES = {
  heroFacade: "https://static.prod-images.emergentagent.com/jobs/419e6f70-6d21-4640-9662-bdf6140c2cbc/images/0da15a1e6f11747983e996f02f8b023b491677c9a0e20092d1da65e26f349ecb.png",
  roofAfter: "https://static.prod-images.emergentagent.com/jobs/419e6f70-6d21-4640-9662-bdf6140c2cbc/images/bd86fb613830754b7f983a64c0d22f1f59f0f7633828e62f55c04a88a12c8020.png",
  roofBefore: "https://static.prod-images.emergentagent.com/jobs/419e6f70-6d21-4640-9662-bdf6140c2cbc/images/04775efb9d5cf3be4ec7f3c236244cfc31bdc45be3cc3a5ff9908b0ff2d79a7d.png",
  facadeBefore: "https://static.prod-images.emergentagent.com/jobs/419e6f70-6d21-4640-9662-bdf6140c2cbc/images/a38280362f5137c1a87a6f9c246dae962ca32e4fdc424cdf9bf0638b71f35c77.png",
  facadeAfter: "https://static.prod-images.emergentagent.com/jobs/419e6f70-6d21-4640-9662-bdf6140c2cbc/images/0da15a1e6f11747983e996f02f8b023b491677c9a0e20092d1da65e26f349ecb.png",
  gutterBefore: "https://static.prod-images.emergentagent.com/jobs/419e6f70-6d21-4640-9662-bdf6140c2cbc/images/0b366256e87d3d76fcaa74275b4ec3c6d29ebf29d02a9ccf84c5e4e67c42049c.png",
  gutterAfter: "https://static.prod-images.emergentagent.com/jobs/419e6f70-6d21-4640-9662-bdf6140c2cbc/images/7065fb1c1e7e4700cb3649b688c3dd12cb42121594258e218cff55dc66514134.png",
  tileTexture: "https://images.unsplash.com/photo-1605450099279-533bd3ce379a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tileTexture2: "https://images.unsplash.com/photo-1614418583513-8e96d9160333?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  roofer1: "https://images.unsplash.com/photo-1635424824800-692767998d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  roofer2: "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  roofer3: "https://images.unsplash.com/photo-1635424825057-7fb6dcd651ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facadeModern: "https://images.unsplash.com/photo-1564703048291-bcf7f001d83d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  roofSky: "https://images.unsplash.com/photo-1563993356056-b23a9cd265ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SERVICES = [
  {
    slug: "renovation-couverture",
    title: "Rénovation de couverture",
    short: "Toiture vieillissante ou fuites ? Nous rénovons votre couverture pour protéger durablement votre maison.",
    benefit: "Une toiture saine, étanche et valorisante pour votre bien.",
    icon: "Home",
    image: "roofAfter",
  },
  {
    slug: "entretien-couverture",
    title: "Entretien de couverture",
    short: "Un entretien régulier prolonge la vie de votre toiture et évite les réparations coûteuses.",
    benefit: "Prévenez les infiltrations et gagnez des années de tranquillité.",
    icon: "Wrench",
    image: "tileTexture",
  },
  {
    slug: "entretien-charpente",
    title: "Entretien de charpente",
    short: "La charpente est le squelette de votre maison. Nous la contrôlons et la traitons.",
    benefit: "Une structure solide, protégée de l'humidité et des insectes.",
    icon: "Ruler",
    image: "roofer3",
  },
  {
    slug: "isolation",
    title: "Isolation",
    short: "Améliorez le confort de votre habitat et réduisez vos factures d'énergie.",
    benefit: "Plus de confort, moins de déperditions, des économies durables.",
    icon: "ThermometerSun",
    image: "facadeModern",
  },
  {
    slug: "demoussage-toiture",
    title: "Démoussage de toiture",
    short: "Mousses et lichens abîment vos tuiles. Nous nettoyons et assainissons votre toit.",
    benefit: "Une toiture propre, préservée et esthétique.",
    icon: "Sparkles",
    image: "roofBefore",
  },
  {
    slug: "traitement-toiture",
    title: "Traitement de toiture",
    short: "Après nettoyage, un traitement protecteur prolonge la durée de vie de votre couverture.",
    benefit: "Une protection longue durée contre les intempéries.",
    icon: "ShieldCheck",
    image: "roofSky",
  },
  {
    slug: "traitement-facade-pignon",
    title: "Traitement des murs de façade et pignon",
    short: "Nous traitons vos façades contre l'humidité, les fissures et le vieillissement.",
    benefit: "Des murs sains, protégés et durablement embellis.",
    icon: "Building2",
    image: "facadeAfter",
  },
  {
    slug: "renovation-gouttiere",
    title: "Rénovation de gouttière zinc / PVC",
    short: "Gouttières abîmées ou percées ? Nous les remplaçons en zinc ou PVC.",
    benefit: "Une évacuation des eaux fiable qui protège vos murs.",
    icon: "Droplets",
    image: "gutterAfter",
  },
  {
    slug: "ravalement",
    title: "Ravalement",
    short: "Redonnez tout son éclat à votre façade avec un ravalement soigné.",
    benefit: "Une maison qui reprend vie et prend de la valeur.",
    icon: "PaintRoller",
    image: "facadeModern",
  },
  {
    slug: "peinture-exterieure",
    title: "Peinture extérieure",
    short: "Une peinture extérieure de qualité protège et embellit votre habitat.",
    benefit: "Un rendu propre, moderne et une protection renforcée.",
    icon: "Brush",
    image: "facadeAfter",
  },
];

export const REASSURANCE = [
  { icon: "Award", title: "15 ans d'expérience", text: "Un savoir-faire éprouvé sur de nombreux domaines du bâtiment." },
  { icon: "Users", title: "3 artisans disponibles", text: "Une équipe à taille humaine, réactive et à votre écoute." },
  { icon: "MapPin", title: "Ancrage local", text: "Basés dans l'Oise, proches de vous et de vos besoins." },
  { icon: "Sparkles", title: "Travail propre et soigné", text: "Un chantier respectueux de votre habitat, du début à la fin." },
  { icon: "ShieldCheck", title: "Spécialiste toiture & habitat", text: "Toiture, façade, isolation : nous couvrons tous vos besoins." },
  { icon: "HeartHandshake", title: "Accompagnement de A à Z", text: "Un interlocuteur unique, du conseil jusqu'à la finition." },
];

export const BEFORE_AFTER = [
  { title: "Rénovation complète de toiture", location: "Oise", before: "roofBefore", after: "roofAfter", desc: "Toiture couverte de mousse entièrement rénovée et traitée." },
  { title: "Ravalement de façade", location: "Île-de-France", before: "facadeBefore", after: "facadeAfter", desc: "Façade vieillissante ravalée pour un rendu propre et durable." },
  { title: "Remplacement de gouttières zinc", location: "Picardie", before: "gutterBefore", after: "gutterAfter", desc: "Gouttières abîmées remplacées par du zinc neuf et fiable." },
];

export const TESTIMONIALS = [
  { name: "Sylvie & Marc D.", city: "Beauvais (60)", text: "Une équipe sérieuse et à l'écoute. Notre toiture était couverte de mousse, aujourd'hui elle est comme neuve. Chantier propre et respect des délais.", rating: 5 },
  { name: "Philippe R.", city: "Compiègne (60)", text: "Devis clair, travail soigné et de vrais conseils. Je recommande sans hésiter pour la rénovation de façade.", rating: 5 },
  { name: "Nathalie B.", city: "Senlis (60)", text: "Intervention rapide pour mes gouttières avant l'hiver. Très professionnels et vraiment à l'écoute des particuliers.", rating: 5 },
];

export const FAQ = [
  { q: "Intervenez-vous chez les particuliers ?", a: "Oui, 95 % de nos clients sont des particuliers. Nous accompagnons les propriétaires de maison dans l'entretien, la rénovation et l'amélioration de leur habitat, avec des explications simples et sans jargon." },
  { q: "Quelles sont vos zones d'intervention ?", a: "Nous intervenons en priorité dans tout le département de l'Oise, ainsi qu'en Île-de-France et en Picardie. N'hésitez pas à nous indiquer votre code postal, nous vous confirmerons notre disponibilité." },
  { q: "Le devis est-il gratuit ?", a: "Oui, l'étude de votre projet et le devis sont gratuits et sans engagement. Nous nous déplaçons pour évaluer précisément vos besoins." },
  { q: "Sous combien de temps intervenez-vous ?", a: "Cela dépend de la nature du chantier et de la saison. Pour les urgences (fuite, gouttière), nous faisons notre possible pour intervenir rapidement. Précisez votre délai souhaité dans votre demande." },
  { q: "Proposez-vous le démoussage et le traitement de toiture ?", a: "Oui. Nous nettoyons votre toiture des mousses et lichens, puis appliquons un traitement protecteur pour prolonger sa durée de vie et préserver son étanchéité." },
  { q: "Puis-je être rappelé plutôt que de remplir un long formulaire ?", a: "Bien sûr. Utilisez notre formulaire « Être rappelé » : indiquez simplement votre nom, votre téléphone et un créneau. Nous vous rappelons rapidement." },
];

export const TYPES_DEMANDE = [
  "Rénovation de couverture",
  "Entretien de couverture",
  "Entretien de charpente",
  "Isolation",
  "Démoussage de toiture",
  "Traitement de toiture",
  "Traitement de façade / pignon",
  "Rénovation de gouttière",
  "Ravalement",
  "Peinture extérieure",
  "Autre / Je ne sais pas",
];

export const ZONES_OISE = [
  "Beauvais", "Compiègne", "Creil", "Senlis", "Chantilly", "Clermont",
  "Nogent-sur-Oise", "Pont-Sainte-Maxence", "Noyon", "Méru", "Crépy-en-Valois", "Liancourt",
];
